var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"menu"},[_c('img',{staticClass:"logo",attrs:{"id":"logo1","src":_vm.imgLeft}}),_vm._v(" "),(_vm.showProgress)?_c('h1',{staticClass:"progress-text"},[_vm._v(_vm._s(_vm.index)+" de "+_vm._s(_vm.total))]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"logo",staticStyle:{"float":"right"},attrs:{"id":"logo2","src":_vm.imgRight}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44af90b1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavTopPresenter.vue
// module id = null
// module chunks = 